import {styled, css} from "styled-components";
import {getTypographyFontStyles} from "app/utils/styles";
import {ISharedProps} from "./types";
import {CryptoValue} from "@housebets/housebets-x-package";

export const Title = styled.div``;
export const Reloads = styled.div``;
export const Line = styled.div``;
export const ReloadsTitle = styled.div``;
export const ReloadsClaims = styled.div``;
export const Left = styled.div``;
export const Right = styled.div``;
export const Badge = styled.div``;
export const NextClaim = styled.div``;
export const ReloadsItems = styled.div``;
export const ReloadsItem = styled.div<ISharedProps>`
    transition: 0.5s;
    background: ${({$fill, $ready, $missed}) =>
        $fill ? "#10C710" : $ready ? "linear-gradient(171.89deg, #FFD762 4.48%, #DB8400 93.76%)" : $missed ? "#B40000" : "#08333c"};
`;
export const SelectWrapper = styled.div``;
export const Total = styled.div``;

export const StyledCryptoValue = styled(CryptoValue)`
    span {
        color: #fff;

        ${getTypographyFontStyles({
            kind: "Sb-16",
        })}
    }
`;

export const ClaimsItem = styled.div<ISharedProps>`
    ${({$available}) => {
        if (!$available) {
            return css`
                background: #1e2a2d;
                border: 1px solid rgba(255, 255, 255, 0.1);
            `;
        }

        return css`
            background: #ff9000;
            border: 1px solid rgba(255, 255, 255, 0.1);
            box-shadow:
                0px 0px 0.952381px rgba(255, 255, 255, 0.64),
                0px 1.90476px 3.80952px rgba(0, 0, 0, 0.24),
                0px 0.952381px 1.90476px rgba(0, 0, 0, 0.56),
                inset 0px 0px 3.80952px rgba(255, 255, 255, 0.24),
                inset 0px 0px 18.0952px 4.7619px rgba(255, 255, 255, 0.35);
        `;
    }}

    z-index: ${({$position = 0, $max = 12}) => {
        return $max - $position;
    }};

    transform: translateY(
        ${({$current = 0, $position = 0, $available}) => {
            if ($position < $current) return "-52px";
            return "0";
        }}
    );

    width: ${({$positionInViewport = 0}) => ($positionInViewport <= 0 ? "100%" : $positionInViewport > 3 ? "50%" : "50%")};

    transition: 1s;

    top: ${({$positionInViewport = 0}) => ($positionInViewport < 0 ? "-52px" : $positionInViewport > 3 ? "90%" : "40px")};

    left: ${({$positionInViewport = 0}) => ($positionInViewport < 0 ? "0" : $positionInViewport > 3 ? "25%" : "10%")};

    opacity: ${({$positionInViewport = 0}) => ($positionInViewport < 0 || $positionInViewport > 3 ? "0" : "1")};

    &.position-0 {
        top: 0px;
        width: 100%;
        left: 0%;
    }

    &.position-1 {
        top: 40px;
        width: 90%;
        left: 5%;
        opacity: 0.9;
        transition-delay: 0.1s;
    }

    &.position-2 {
        top: 81px;
        width: 80%;
        left: 10%;
        opacity: 0.5;
        transition-delay: 0.2s;
    }

    &.position-3 {
        top: 120px;
        width: 70%;
        left: 15%;
        opacity: 0.4;
        transition-delay: 0.3s;
    }
`;

export const Box = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;

    color: #fff;

    ${getTypographyFontStyles({
        kind: "R-16",
    })}

    ${Title} {
        text-align: left;
        width: 100%;
    }

    ${SelectWrapper} {
        width: 100%;
    }

    ${Reloads} {
        display: flex;
        flex-direction: column;
        gap: 32px;
    }

    ${Line} {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    ${ReloadsTitle} {
    }

    ${ReloadsClaims} {
        position: relative;
        width: 100%;
        height: 172px;

        overflow: hidden;
    }

    ${ClaimsItem} {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        gap: 10px;
        max-height: 52px;

        border-radius: 8px;

        ${Left} {
            display: flex;
            align-items: center;
            gap: 10px;

            ${getTypographyFontStyles({
                kind: "M-14",
            })}
        }

        ${NextClaim} {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 12px;
            gap: 10px;

            background: rgba(255, 150, 28, 0.12);
            border-radius: 100px;

            color: #ff961c;

            ${getTypographyFontStyles({
                kind: "R-12",
            })}
        }

        ${Badge} {
            padding: 3px 12px;
            background: #fff;
            border-radius: 100px;
            color: #26ba50;

            ${getTypographyFontStyles({
                kind: "R-12",
            })}
        }

        ${NextClaim} {
        }
    }

    ${ReloadsItems} {
        display: flex;
        flex-direction: row;
        gap: 4px;
    }

    ${ReloadsItem} {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        padding: 2px;

        width: 100%;
        height: 30px;
        border-radius: 4px;
    }
`;
